import { AutoComplete, Badge, Button, Image, Input, message, Modal, Switch, Table, Tooltip, Upload } from 'antd';
import './index.less';
import { ReactComponent as OpenUseLogSvg } from "./icon/open-use-log.svg";
import { useContext, useEffect, useRef, useState } from 'react';
import { FeedbackReply, UserFeedback } from '@/declare/interface/feedback/user-feedback';
import { createUserFeedback, deleteUserFeedbacks, getFeedbackFileUrl, getFunctionPointsByKeyword, getPendingVerificationCount, getUserFeedbacks, multiUpdateFeedbackStatus, replyMultiFeedback, updateUserFeedback } from '@/declare/api/feedback/user-feedback';
import dayjs from 'dayjs';
import TextArea from 'antd/lib/input/TextArea';
import { ReactComponent as FaSendSvg } from './icon/fa_send.svg';
import { ReactComponent as FileSvg } from './icon/file.svg';
import classNames from 'classnames';
import { UserFeedbackUploadFileContext } from '@/App';
import UserFeedbackUploadPanel, { UserFeedbackFileUploadParam, UserFeedbacUploadFileLocale } from './upload-panel';
import localStore from '@/store/local-store';
import { SOFTWARE_PROJECT_ID, SOFTWARE_PROJECT_NAME } from '@/store/constant';
import Icon, {
    ExclamationCircleOutlined,
    CloseCircleOutlined,
} from '@ant-design/icons'
import DragModal from '@/baseui/drag-modal/DragModal';
import TnPmModal from '@/baseui/modal';
import ContextMenu from '@/baseui/right-menu/context-menu';
import MenuList from '@/baseui/right-menu/menu-list';
import MenuItem from '@/baseui/right-menu/menu-item';
import { ReactComponent as PassSvg } from './icon/pass.svg';
import { ReactComponent as PassActiveSvg } from './icon/pass-active.svg';
import { ReactComponent as CheckSvg } from './icon/check.svg';
import { ReactComponent as CheckedSvg } from './icon/checked.svg';
import { ReactComponent as ReplySvg } from './icon/reply.svg';
import { ReactComponent as ReplyActiveSvg } from './icon/reply-active.svg';
import { ReactComponent as DeleteSvg } from './icon/delete.svg';
import { ReactComponent as DeleteActiveSvg } from './icon/delete-active.svg';
import { ReactComponent as RepairSvg } from './icon/repair.svg';
import { ReactComponent as RepairActiveSvg } from './icon/repair-active.svg';
import UserFeedbackDetail from './feedback-detail';
import { emitter, EMITTER_TYPE } from '@/store/mitt';
import ImagePasteListener from './image-paste-listener';


interface IBtnProps {
    visible: boolean
    changeVisible: (visible: boolean) => void;
}

export const UserFeedbackActiveBtn = (props: IBtnProps) => {
    const userName = localStore.name;
    const projectId = SOFTWARE_PROJECT_ID;
    const projectName = SOFTWARE_PROJECT_NAME;
    const [count, setCount] = useState<number>(); // 已响应的数量

    const timeIntervalRef = useRef(null);
    useEffect(() => {
        const count = () => {
            getPendingVerificationCount(projectId, userName).then(res => {
                let count = res.data;
                setCount(count)
            })
        }
        count();
        timeIntervalRef.current = setInterval(() => {
            count();
        }, 10 * 60 * 1000)

        emitter.on(EMITTER_TYPE.FEEDBACK_UPDATE, count);
        return () => {
            emitter.off(EMITTER_TYPE.FEEDBACK_UPDATE, count);
            if (timeIntervalRef.current) {
                clearInterval(timeIntervalRef.current);
                timeIntervalRef.current = null;
            }
        }
    }, [projectId, userName])



    return <div className='user-feedback-active-btn-container' >
        <Tooltip title="反馈">
            <Badge count={count} showZero={false} size='small' offset={[2, 0]}>
                <div className='btn' onClick={() => props.changeVisible(true)}><OpenUseLogSvg /></div>
            </Badge>
        </Tooltip>
    </div>
}

interface IProps {
    visible: boolean
    changeVisible: (visible: boolean) => void;
}

const Upload_BUCKET_NAME = "tndas";

export interface FunctionPoint {
    id?: number;
    gmtCreate?: number;
    name?: string;
}

interface TnFile {
    fileMd5: string,
    fileSize: number,
    fileSuffix: string,
    filePath: string,
    url: string
}

export const ResponseStatus = {
    UN_RESPONDED: 1, // 未响应
    RESPONDED: 2, // 已响应
    TO_BE_IMPROVED: 3, // 待完善
    COMPLETED: 4, // 已完成
}
/**
 * 根据类型获取状态文字
 */
export const getFeedbackLabelByType = (type: number): string => {
    switch (type) {
        case ResponseStatus.UN_RESPONDED:
            return "未响应";
        case ResponseStatus.RESPONDED:
            return "已响应";
        case ResponseStatus.TO_BE_IMPROVED:
            return "待完善";
        case ResponseStatus.COMPLETED:
            return "已完成";
        default:
            return "未知状态";
    }
};
const getResponseStatusList = () => {
    return [
        { label: '未响应', value: ResponseStatus.UN_RESPONDED },
        { label: '已响应', value: ResponseStatus.RESPONDED },
        { label: '待完善', value: ResponseStatus.TO_BE_IMPROVED },
        { label: '已完成', value: ResponseStatus.COMPLETED },
    ]
}

export default function UserFeedBackPanel(props: IProps) {

    const uploadFileContext = useContext(UserFeedbackUploadFileContext);

    const projectId = SOFTWARE_PROJECT_ID;
    const projectName = SOFTWARE_PROJECT_NAME;

    const [feedbacks, setFeedbacks] = useState<UserFeedback[]>([]);
    const [inputValue, setInputValue] = useState<string>('');
    const [keywordValue, setKeywordValue] = useState<string>('');

    const feedbacksRef = useRef<UserFeedback[]>();

    const inputValueRef = useRef<string>();
    const keywordValueRef = useRef<string>();
    const selectedFunctionPointIdRef = useRef<number>();

    const [sendLoading, setSendLoading] = useState(false);

    const [uploadFileList, setUploadFileList] = useState([]);
    const [file, setFile] = useState<TnFile>(null);
    const fileRef = useRef(file);

    // 右键
    const [cmVisible, setCmVisible] = useState(false);
    const [cmFeedbackId, setCmFeedbackId] = useState(0);
    const [cmTop, setCmTop] = useState(0);
    const [cmLeft, setCmLeft] = useState(0);
    const [editFeedBackId, setEditFeedbackId] = useState(null);
    const [keyword, setKeyword] = useState(''); // 关键词
    const [content, setContent] = useState(''); // 内容

    const [keywords, setKeywords] = useState<any[]>([]); // 关键词数组

    // const [resolved, setResolved] = useState<boolean>(false); // 是否选中了已处理
    const [selectedStatus, setSelectedStatus] = useState<number>(null); // 选中的筛选状态
    const [onlyMine, setOnlyMine] = useState<boolean>(false); // 是否仅查看我提出的问题
    const userName = localStore.name
    const [selectedRowKeys, setSelectedRowKeys] = useState<number[]>([]); // 选中的用户反馈id数组
    const [selectedFeedback, setSelectedFeedback] = useState<UserFeedback>(); // 当前选中的用户反馈
    // 回复弹窗
    const [replyOpen, setReplyOpen] = useState<boolean>(false);

    const [count, setCount] = useState<number>(); // 已响应的数量

    const [functionPoints, setFunctionPoints] = useState<FunctionPoint[]>([]); // 功能点列表
    const [selectedFunctionPointId, setSelectedFunctionPointId] = useState<number>(); // 选中的功能点id
    const tableRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (tableRef.current) {
            const body = tableRef.current.querySelector(".ant-table-body");
            if (body) {
                body.scrollTop = body.scrollHeight;
            }
        }
    }, [feedbacks, selectedStatus]); // 数据变化时自动滚动到底部

    useEffect(() => {
        selectedFunctionPointIdRef.current = selectedFunctionPointId
    }, [selectedFunctionPointId])

    useEffect(() => {
        feedbacksRef.current = feedbacks;
    }, [feedbacks])

    useEffect(() => {
        inputValueRef.current = inputValue;
    }, [inputValue])

    useEffect(() => {
        keywordValueRef.current = keywordValue;
    }, [keywordValue])

    useEffect(() => {
        if (selectedRowKeys.length == 0) {
            setReplyOpen(false);
        }
    }, [selectedRowKeys])

    useEffect(() => {
        if (!props.visible) return;
        setReplyOpen(false)
        getPendingVerificationCount(projectId, userName).then(res => {
            let count = res.data;
            setCount(count)
            if (count > 0) {
                setSelectedStatus(ResponseStatus.RESPONDED);
                setOnlyMine(true)
            } else {
                setSelectedStatus(null)
                setOnlyMine(false)
            }
        })
        getUserFeedbacks({ projectId: SOFTWARE_PROJECT_ID, functionPointId: -1 }).then(res => {
            let feedbacks = res.data || []
            setFeedbacks(feedbacks);
            let keywords = [];
            feedbacks.forEach(item => {
                if (item.keyword && item.keyword?.trim().length > 0) {
                    keywords.push({ label: item.keyword.trim(), value: item.keyword.trim() })
                }
            })
            // 去重
            keywords = keywords.filter((item, index, self) =>
                index === self.findIndex((t) => (
                    t.value === item.value
                ))
            );
            setKeywords(keywords);
            scrollToBottom();
        }).catch(err => {
            message.error("获取反馈失败")
        })

    }, [props.visible])

    useEffect(() => {
        fileRef.current = file;
    }, [file])

    useEffect(() => {
        if (!props.visible || selectedFeedback != null) return;
        window.addEventListener('keydown', onKeydown);
        return () => {
            window.removeEventListener('keydown', onKeydown);
        }
    }, [props.visible, selectedFeedback, replyOpen])

    useEffect(() => {
        if (uploadFileList.length === 0) return;
        let files: UserFeedbacUploadFileLocale[] = uploadFileList.map(item => {
            return {
                file: item,
                callbackFn: uploadCallbackFn
            }
        })
        uploadFileContext.startUpload(files)
    }, [uploadFileList])

    useEffect(() => {
        if (!uploadFileContext.visible) {
            setUploadFileList([]);
        }
    }, [uploadFileContext.visible])

    const uploadCallbackFn = (uploadFile: UserFeedbackFileUploadParam) => {
        return new Promise(resolve => {
            const file: TnFile = {} as TnFile;
            file.fileMd5 = uploadFile.md5;
            file.fileSize = uploadFile.fileSize;
            file.fileSuffix = uploadFile.suffix;
            file.filePath = uploadFile.filePath;

            getFeedbackFileUrl(file.filePath, Upload_BUCKET_NAME).then(res => {
                if (res.status === 200) {
                    file.url = res.data;
                    setFile({ ...file });
                }
            }).finally(() => {
                resolve(true);
            })
        })
    }

    const handleImagePaste = (file: File) => {
        if (selectedFeedback) {
            return;
        }
        beforeUpload(file, [file]);
    };

    const onKeydown = (e) => {
        if (replyOpen) {
            let inputValue = inputValueRef.current
            if (e.ctrlKey && e.key === 'Enter') {
                if (inputValue.length <= 0) {
                    message.error('请输入反馈内容');
                    return;
                };
                sendFeekbackReply();
            } else if (e.ctrlKey && e.key === 'v') {
                // navigator.clipboard.read()
                //     .then(items => {
                //         items.forEach(item => {
                //             if (item.types.includes('image/png')) {
                //                 item.getType('image/png').then(blob => {
                //                     const file = new File([blob], '反馈图片.png', { type: blob.type });
                //                     beforeUpload(file, [file]);
                //                 }).catch(err => {
                //                     message.error("粘贴图片失败");
                //                 });
                //             }
                //         });
                //     }).catch(err => {
                //     });
            }
        } else {
            let keywordValue = keywordValueRef.current
            let inputValue = inputValueRef.current
            if (e.ctrlKey && e.key === 'Enter') {
                if (inputValue.length <= 0 || keywordValue.length <= 0) {
                    message.error('请输入反馈内容和关键词');
                    return;
                };
                sendFeekback();
            } else if (e.ctrlKey && e.key === 'v') {
                // navigator.clipboard.read()
                //     .then(items => {
                //         items.forEach(item => {
                //             if (item.types.includes('image/png')) {
                //                 item.getType('image/png').then(blob => {
                //                     const file = new File([blob], '反馈图片.png', { type: blob.type });
                //                     beforeUpload(file, [file]);
                //                 }).catch(err => {
                //                     message.error("粘贴图片失败");
                //                 });
                //             }
                //         });
                //     }).catch(err => {
                //         // message.error("获取剪贴板内容失败：" + err)
                //     });
            }
        }
    }

    const sendFeekback = () => {
        const name = localStore.name || '未知'
        if (!name) return;
        let keywordValue = keywordValueRef.current
        let inputValue = inputValueRef.current
        if (keywordValue === '') {
            message.warning('请输入主题')
            return;
        }
        if (inputValue === '') {
            message.warning('请输入内容')
            return;
        }
        let dataIn: UserFeedback = {
            userName: name,
            content: inputValue,
            keyword: keywordValue,
            projectId: projectId,
            projectName: projectName,
            responseStatus: ResponseStatus.UN_RESPONDED,
            relateFunctionPointId: selectedFunctionPointIdRef.current,
        } as UserFeedback
        // ctrl enter是事件绑定，拿不到新的文件
        if (fileRef.current != null) {
            dataIn = {
                ...dataIn,
                ...fileRef.current
            }
        }
        setSendLoading(true)
        createUserFeedback(dataIn).then(res => {
            if (res.status === 200 && res.data) {
                // message.success('发送成功');
                dataIn.id = res.data;
                dataIn.gmtCreate = dayjs().valueOf();
                dataIn.gmtUpdate = dayjs().valueOf();
                dataIn.status = false;
                setFeedbacks([...feedbacksRef.current, dataIn])
                scrollToBottom();
            }
        }).catch(() => {
            message.error('发送失败');
        }).finally(() => {
            setInputValue('');
            setKeywordValue('');
            setFile(null);
            setSendLoading(false);
        })
    }

    const sendFeekbackReply = () => {
        const name = localStore.name || '未知'
        if (!name) return;
        let inputValue = inputValueRef.current
        if (inputValue === '') {
            message.warning('请输入内容')
            return;
        }
        let dataIn: FeedbackReply = {
            userName: name,
            content: inputValue,
            projectId: +projectId,
        }
        // ctrl enter是事件绑定，拿不到新的文件
        if (fileRef.current != null) {
            dataIn = {
                ...dataIn,
                ...fileRef.current
            }
        }
        setSendLoading(true)
        replyMultiFeedback(selectedRowKeys, dataIn).then(res => {
            if (res.status === 200 && res.data) {
                message.success('回复成功');
                setSelectedRowKeys([])
            }
        }).catch(() => {
            message.error('回复失败');
        }).finally(() => {
            setInputValue('');
            setKeywordValue('');
            setFile(null);
            setSendLoading(false);
        })
    }

    const scrollToBottom = () => {
        setTimeout(() => {
            const list = document.getElementById('feedback-list');
            if (list === null || list.children.length === 0) return;
            list.children[list.children.length - 1].scrollIntoView({ behavior: 'smooth', block: 'end' });
        }, 200);
    }

    const beforeUpload = (file, fileList) => {
        if (!file.type.includes('image')) {
            message.error('请上传图片');
            return false;
        }
        if (uploadFileList.length === 0) {
            setUploadFileList([...fileList]);
        }
        return false;
    }

    // 右键
    const onContextMenu = (e, feedbackId: number) => {
        e.preventDefault();
        if (cmFeedbackId === feedbackId || editFeedBackId === feedbackId) return;
        setEditFeedbackId(null);
        const name = localStore.name || '未知'
        const feed = feedbacks.find(f => f.id === feedbackId);
        if (!feed || feed.userName !== name || (feed.userName !== name && feed.userName === "未知")) return;
        setCmFeedbackId(feedbackId);
        setCmVisible(true);
        setCmTop(e.clientY);
        setCmLeft(e.clientX);
    }

    // 激活编辑
    const activeEditFeedback = () => {
        setCmVisible(false);
        const feed = feedbacks.find(f => f.id === cmFeedbackId);
        if (!feed) return;
        setEditFeedbackId(cmFeedbackId);
        setCmFeedbackId(null);
        setKeyword(feed.keyword);
        setContent(feed.content);
    }

    // 激活删除
    const activeDeleteFeedback = () => {
        setCmVisible(false);
        Modal.confirm({
            title: '删除',
            icon: <ExclamationCircleOutlined style={{ color: '#FF4D4F' }} />,
            content: '是否确认删除？',
            okText: '确认',
            cancelText: '取消',
            wrapClassName: 'project-activity-modal',
            okButtonProps: {
                className: 'ok-btn'
            },
            cancelButtonProps: {
                className: 'cancel-btn'
            },
            onOk: () => {
                deleteUserFeedbacks([cmFeedbackId]).then(res => {
                    const idx = feedbacks.findIndex(f => f.id === cmFeedbackId);
                    feedbacks.splice(idx, 1);
                    setFeedbacks([...feedbacks]);
                    // message.success('删除成功');
                }).catch(err => {
                    message.error('删除失败');
                }).finally(() => {
                    Modal.destroyAll();
                    setCmFeedbackId(null);
                })
            }
        });
    }

    // 保存
    const onSave = () => {
        const feed = feedbacks.find(f => f.id === editFeedBackId);
        if (!feed) {
            return;
        }
        if (keyword == null || keyword === '') {
            message.warning("关键词不能为空");
            return;
        }
        if (content == null || content === '') {
            message.warning("内容不能为空");
            return;
        }
        setEditFeedbackId(null);
        feed.keyword = keyword;
        feed.content = content;
        setKeyword('');
        setContent('');
        updateUserFeedback(editFeedBackId, feed).then(res => {
            // message.success("修改成功");
            setFeedbacks([...feedbacks]);
        }).catch(err => {
            message.error("修改失败");
        })
    }

    const onCancel = () => {
        setEditFeedbackId(null);
        setKeyword('');
        setContent('');
    }

    const onClickPass = async () => {
        if (selectedRowKeys?.length < 1) {
            message.warning("未选中条目")
            return
        }
        let selectedItems = feedbacks.filter(item => selectedRowKeys.includes(item.id));
        let newSelectedIds = selectedItems.filter(item => item.userName == userName).map(item => item.id);
        if (newSelectedIds.length == 0) {
            message.warning("仅能验证通过自己发的反馈")
            return;
        }
        multiUpdateFeedbackStatus(selectedRowKeys, ResponseStatus.COMPLETED).then(res => {
            let newList = feedbacks;
            newList.forEach(item => {
                if (selectedRowKeys.includes(item.id)) {
                    item.responseStatus = ResponseStatus.COMPLETED
                }
            })
            setFeedbacks([...newList])
            setSelectedRowKeys([])
            message.success(`成功通过${newSelectedIds.length}条反馈`)
            emitter.emit(EMITTER_TYPE.FEEDBACK_UPDATE)
        })
    }

    // 不通过
    const onClickRepair = async () => {
        if (selectedRowKeys?.length < 1) {
            message.warning("未选中条目")
            return
        }
        let selectedItems = feedbacks.filter(item => selectedRowKeys.includes(item.id));
        let newSelectedIds = selectedItems.filter(item => item.userName == userName).map(item => item.id);
        if (newSelectedIds.length == 0) {
            message.warning("仅能不通过自己发的反馈")
            return;
        }
        multiUpdateFeedbackStatus(selectedRowKeys, ResponseStatus.TO_BE_IMPROVED).then(res => {
            let newList = feedbacks;
            newList.forEach(item => {
                if (selectedRowKeys.includes(item.id)) {
                    item.responseStatus = ResponseStatus.TO_BE_IMPROVED
                }
            })
            setFeedbacks([...newList])
            setSelectedRowKeys([])
            message.success(`成功不通过${newSelectedIds.length}条反馈`)
            emitter.emit(EMITTER_TYPE.FEEDBACK_UPDATE)
        })
    }

    const onClickReply = () => {
        if (selectedRowKeys?.length < 1) {
            message.warning("未选中条目")
            return
        }
        setReplyOpen(true)
        message.info("请在下方输入回复内容")
    }

    const onClickDelete = () => {
        if (selectedRowKeys?.length < 1) {
            message.warning("未选中条目")
            return
        }
        let selectedItems = feedbacks.filter(item => selectedRowKeys.includes(item.id));
        let newSelectedIds = selectedItems.filter(item => item.userName == userName).map(item => item.id);
        if (newSelectedIds.length == 0) {
            message.warning("仅能删除自己发的反馈")
            return;
        }
        Modal.confirm({
            title: '删除',
            content: '确认删除吗？',
            okText: '删除',
            cancelText: '取消',
            closable: false,
            async onOk() {
                Modal.destroyAll();
                deleteUserFeedbacks(newSelectedIds).then(res => {
                    let newList = feedbacks;
                    newList = newList.filter(item => !newSelectedIds.includes(item.id))
                    setFeedbacks([...newList])
                    setSelectedRowKeys([])
                    message.success(`成功删除${newSelectedIds.length}条反馈`)
                })
            },
            onCancel() {
                Modal.destroyAll();
            }
        })
    }

    useEffect(() => {
        findFunctionPoints(keywordValue)
    }, [keywordValue])

    let $timer;

    const findFunctionPoints = (keyword: string = null) => {
        if (!keyword) {
            setFunctionPoints([])
            return;
        }
        clearTimeout($timer);
        $timer = setTimeout(() => {
            getFunctionPointsByKeyword(projectId, keyword).then(res => {
                let list = res.data || []
                setFunctionPoints([...list])
            })
        }, 100)
    }

    const rowSelection = {
        selectedRowKeys,
        onChange: (newSelectedRowKeys: number[]) => {
            setSelectedRowKeys(newSelectedRowKeys);
        },
    };


    const selectedLength = selectedRowKeys.length

    return (
        <>
            <Modal
                title={<div className="header">
                    记录
                    <div className="group-list">
                        {[{ value: null, label: '全部' }, ...getResponseStatusList()].map(item => (
                            <div key={item?.value} className={classNames({
                                "group-name": true,
                                "group-name-active": selectedStatus === item.value,
                            })} onClick={(e) => {
                                e.stopPropagation();
                                setSelectedStatus(item.value)
                            }}>
                                <div className="text">{item.label}
                                    {feedbacks.filter(data => (onlyMine == false || data.userName == userName) && (item.value == null || data.responseStatus == item.value)).length}
                                </div>
                            </div>
                        ))}
                    </div>
                    <Switch style={{ width: '80px' }} checkedChildren="仅自己" unCheckedChildren="全部" checked={onlyMine} onChange={(value) => setOnlyMine(value)} />
                    <div className="ope-btns">

                        <Tooltip title="验证通过">
                            <div className="ope-btn" onClick={onClickPass}>{selectedLength > 0 ? <PassActiveSvg /> : <PassSvg />}</div>
                        </Tooltip>
                        <Tooltip title="验证不通过">
                            <div className="ope-btn" onClick={onClickRepair}>{selectedLength > 0 ? <RepairActiveSvg /> : <RepairSvg />}</div>
                        </Tooltip>
                        <Tooltip title="回复">
                            <div className="ope-btn" onClick={onClickReply}>{selectedLength > 0 ? <ReplyActiveSvg /> : <ReplySvg />}</div>
                        </Tooltip>
                        <Tooltip title="删除">
                            <div className="ope-btn" onClick={onClickDelete}>{selectedLength > 0 ? <DeleteActiveSvg /> : <DeleteSvg />}</div>
                        </Tooltip>
                    </div>
                </div>}
                open={props.visible}
                mask
                wrapClassName='user-feedback-modal-container'
                width={860}
                footer={null}
                onCancel={() => props.changeVisible(false)}
            >
                <div className='feedback-box' ref={tableRef}>
                    <Table
                        dataSource={feedbacks.filter(item => (onlyMine == false || item.userName == userName) && (selectedStatus == null || item.responseStatus == selectedStatus))}
                        rowSelection={rowSelection}
                        className="feedback-table-main"
                        rowKey="id"
                        pagination={false}
                        // pagination={{
                        //     current: currentPage,          // 当前页码
                        //     pageSize: pageSize,            // 每页条数
                        //     total: totalCount,             // 数据总数
                        //     showSizeChanger: true,         // 是否可以切换每页条数
                        //     showQuickJumper: false,         // 是否显示快速跳转输入框
                        //     pageSizeOptions: [10, 20, 50], // 可选分页大小
                        //     onChange: (page, size) => {
                        //         setCurrentPage(page)
                        //         setPageSize(size)
                        //     },
                        // }}
                        scroll={{
                            y: "480px"
                        }}
                        onRow={(record) => ({
                            onDoubleClick: (e) => setSelectedFeedback(record),
                        })}
                    >
                        <Table.Column
                            width={80}
                            title="关键词"
                            dataIndex="keyword"
                        />
                        <Table.Column
                            title="内容"
                            dataIndex="content"
                            render={(value: any, data: UserFeedback) => (
                                <div className="table-content">
                                    {value}
                                </div>
                            )}
                        />
                        <Table.Column
                            width={50}
                            title="截图"
                            render={(value: any, data: UserFeedback) => (
                                <span onClick={(e) => e.stopPropagation()}>
                                    {data.fileMd5 && <Image className="table-image" src={data.url} />}
                                </span>
                            )}
                        />
                        <Table.Column
                            width={80}
                            title="状态"
                            render={(value: any, data: UserFeedback) => (
                                <div className={classNames({
                                    "table-status": true,
                                    "table-status-1": data.responseStatus == ResponseStatus.UN_RESPONDED,
                                    "table-status-2": data.responseStatus == ResponseStatus.RESPONDED,
                                    "table-status-3": data.responseStatus == ResponseStatus.TO_BE_IMPROVED,
                                    "table-status-4": data.responseStatus == ResponseStatus.COMPLETED,
                                })}>
                                    {getFeedbackLabelByType(data.responseStatus)}
                                </div>
                            )}
                        />
                        <Table.Column
                            width={60}
                            title="发起人"
                            dataIndex="userName"
                        />
                        <Table.Column
                            width={125}
                            title="发起时间"
                            render={(value: any, data: UserFeedback) => (
                                <>
                                    {dayjs(data.gmtCreate).format('YYYY/MM/DD HH:mm')}
                                </>
                            )}
                        />
                    </Table>
                    {/* <div id="feedback-list" className='feedback-list'>
                        {feedbacks.filter(item => (onlyMine == false || item.userName == userName) && (selectedStatus == null || item.responseStatus == selectedStatus)).map(feedback => {
                            return <div id={feedback.id.toString()} className={classNames({
                                'feedback-item': true,
                                'resolved': feedback.status
                            })} key={feedback.id} onClick={() => setSelectedFeedback(feedback)}>
                                <div className="check-icon">
                                    {selectedIds.includes(feedback.id) && <CheckedSvg onClick={() => {
                                        let newList = selectedIds.filter(item => item != feedback.id)
                                        setSelectedIds(newList)
                                    }} />}
                                    {!selectedIds.includes(feedback.id) && <CheckSvg onClick={() => {
                                        setSelectedIds([...selectedIds, feedback.id])
                                    }} />}
                                </div>
                                <div className='top'>
                                    <div className='title'>
                                        <div className={classNames({
                                            'keyword': true,
                                            'edit': editFeedBackId === feedback.id
                                        })}>
                                            {editFeedBackId !== feedback.id && feedback?.keyword}
                                            {editFeedBackId === feedback.id && <Input value={keyword}
                                                onChange={(e) => setKeyword(e.target.value)} />}
                                        </div>
                                        <div className='username'>{feedback?.userName}</div>
                                        <div className='time'>{dayjs(feedback?.gmtCreate).format('YYYY/MM/DD HH:mm')}</div>
                                    </div>
                                    {feedback.id === editFeedBackId &&
                                        <div style={{ display: 'flex', gap: '8px' }}>
                                            <Button type='primary' size='small' onClick={onSave}>保存</Button>
                                            <Button size='small' onClick={onCancel}>取消</Button>
                                        </div>
                                    }
                                </div>
                                <div className='content' onContextMenu={(e) => onContextMenu(e, feedback.id)}>
                                    {editFeedBackId !== feedback.id && feedback?.content}
                                    {editFeedBackId === feedback.id && <Input value={content}
                                        onChange={(e) => setContent(e.target.value)} />}</div>
                                {feedback?.fileMd5 && feedback?.url && <div className='img'>
                                    <Image src={feedback?.url} />
                                </div>}
                            </div>
                        })} 
                    </div>*/}
                    <div className='feedback-input'>
                        <TextArea
                            readOnly={sendLoading}
                            className='content-input'
                            placeholder={`请输入${replyOpen ? `回复` : `反馈`}内容 Ctrl+Enter可发送 Ctrl+V上传粘贴板图片(仅可保留一张)`}
                            autoSize={{ minRows: 4, maxRows: 4 }}
                            value={inputValue}
                            onChange={(e) => setInputValue(e.target.value)} />
                        <div className='ope-area'>
                            {!replyOpen && <AutoComplete
                                className='keyword-input'
                                placeholder='功能'
                                maxLength={10}
                                // options={keywords.filter(item => item.value.match(new RegExp(keywordValue, 'i')))}
                                value={keywordValue}
                                onChange={(value) => {
                                    setKeywordValue(value)
                                    setSelectedFunctionPointId(null);
                                }}
                                options={(keywordValue?.trim()?.length == 0 ? [...keywords.filter(item => item.value.match(new RegExp(keywordValue, 'i')))] : [...functionPoints.map(item => { return { id: item.id, label: item.name, value: item.name } })])?.map(item => {
                                    return {
                                        label: `${item.label}`,
                                        value: item.value,
                                        row: item
                                    }
                                })}
                                onSelect={(value, option) => {
                                    let functionPoint: FunctionPoint = option.row;
                                    if (functionPoint.id != null) {
                                        setSelectedFunctionPointId(functionPoint.id);
                                    }
                                    setKeywordValue(value)
                                }}
                                onBlur={() => {
                                    if (functionPoints.length > 0) {
                                        setSelectedFunctionPointId(functionPoints[0].id)
                                    } else {
                                        setSelectedFunctionPointId(null)
                                    }
                                }}
                            />}

                            {/* <Input
                                readOnly={sendLoading}
                                className='keyword-input'
                                placeholder='反馈关键词'
                                maxLength={10}
                                value={keywordValue}
                                onChange={(e) => setKeywordValue(e.target.value)} /> */}
                            <span className='fill-remaining-space'></span>
                            {file && <div style={{ position: 'relative' }}>
                                <Image src={file.url} width={32} height={32} />
                                <CloseCircleOutlined style={{ position: 'absolute', right: '-6px', top: '-6px', color: 'red' }} onClick={() => setFile(null)} />
                            </div>}
                            {!file && <Upload showUploadList={false} beforeUpload={beforeUpload} className="file-upload-wrapper">
                                <FileSvg className='file-upload-icon' />
                            </Upload>}
                            <FaSendSvg onClick={() => {
                                if (replyOpen) {
                                    if (inputValue.length <= 0) {
                                        message.error('请输入反馈内容');
                                        return;
                                    };
                                    sendFeekbackReply();
                                } else {
                                    if (inputValue.length <= 0 || keywordValue.length <= 0) {
                                        message.error('请输入反馈内容和关键词');
                                        return;
                                    };
                                    sendFeekback();
                                }
                            }} className={classNames({
                                'send-btn': true,
                                'disabled': inputValue.length <= 0 || sendLoading
                            })} />

                        </div>
                    </div>
                </div>
                <UserFeedbackUploadPanel />
                {/* 注入监听器 */}
                <ImagePasteListener onImagePaste={handleImagePaste} />
            </Modal >
            <Modal title={<div className="header">{selectedFeedback?.keyword}</div>}
                open={selectedFeedback != null}
                mask
                wrapClassName='user-feedback-modal-container'
                width={860}
                footer={null}
                destroyOnClose
                onCancel={() => setSelectedFeedback(null)}
            >
                <div className="feedback-box">
                    <UserFeedbackDetail feedbackId={selectedFeedback?.id} onUpdateStatus={(status) => {
                        let newList = feedbacks;
                        let index = newList.findIndex(item => item.id == selectedFeedback?.id);
                        if (index >= 0) {
                            newList.splice(index, 1, { ...feedbacks[index], responseStatus: status })
                            setFeedbacks([...newList])
                        }
                    }} />
                </div>
            </Modal>
            <ContextMenu
                visible={cmVisible}
                left={cmLeft}
                top={cmTop}
                width={140}
                onCancel={() => {
                    setCmVisible(false);
                }}
                wrapperClassname='feedback-cm-container'
            >
                <MenuList>
                    <MenuItem onClick={activeEditFeedback}>编辑</MenuItem>
                    <MenuItem onClick={activeDeleteFeedback}>删除</MenuItem>
                </MenuList>
            </ContextMenu>
        </>
    )
    //         <div id="feedback-list" className='feedback-list'>
    //             {feedbacks.map(feedback => {
    //                 return <div id={feedback.id.toString()} className='feedback-item' key={feedback.id}>
    //                     <div className='top'>
    //                         <div className='title'>
    //                             <div className='keyword'>{feedback?.keyword}</div>
    //                             <div className='username'>{feedback?.userName}</div>
    //                             <div className='time'>{dayjs(feedback?.gmtCreate).format('YYYY/MM/DD HH:mm')}</div>
    //                         </div>
    //                     </div>
    //                     <div className='content'>{feedback?.content}</div>
    //                     {feedback?.fileMd5 && feedback?.url && <div className='img'>
    //                         <Image src={feedback?.url} />
    //                     </div>}
    //                 </div>
    //             })}
    //         </div>
    //         <div className='feedback-input'>
    //             <TextArea
    //                 readOnly={sendLoading}
    //                 className='content-input'
    //                 placeholder='请输入反馈内容 Ctrl+Enter可发送 Ctrl+V上传粘贴板图片(仅可保留一张)'
    //                 autoSize={{ minRows: 4, maxRows: 4 }}
    //                 value={inputValue}
    //                 onChange={(e) => setInputValue(e.target.value)} />
    //             <div className='ope-area'>
    //                 <Input
    //                     readOnly={sendLoading}
    //                     className='keyword-input'
    //                     placeholder='反馈关键词'
    //                     maxLength={10}
    //                     value={keywordValue}
    //                     onChange={(e) => setKeywordValue(e.target.value)} />
    //                 <span className='fill-remaining-space'></span>
    //                 <Upload showUploadList={false} beforeUpload={beforeUpload} className="file-upload-wrapper">
    //                     <FileSvg className='file-upload-icon' />
    //                 </Upload>
    //                 <FaSendSvg onClick={() => {
    //                     if (inputValue.length <= 0 || keywordValue.length <= 0) {
    //                         message.error('请输入反馈内容和关键词');
    //                         return;
    //                     };
    //                     sendFeekback();
    //                 }} className={classNames({
    //                     'send-btn': true,
    //                     'disabled': inputValue.length <= 0 || sendLoading
    //                 })} title='发送' />

    //             </div>
    //         </div>
    //     </div>

    //     <UserFeedbackUploadPanel />
    // </Modal>
}